import LinearProgress from "@mui/material/LinearProgress";
import {useNavigation} from "react-router";

/**
 * Barre de progression affichée pendant que le routeur charge l'écran visé.
 *
 * Les écrans sont chargés à la demande (cf. `src/index.tsx`) : à la première ouverture de chacun, le
 * routeur attend son chunk avant de naviguer, et l'écran précédent reste affiché. Sans indication,
 * un clic semblerait sans effet sur un réseau lent. Une barre fine plutôt que le loader global :
 * ce dernier assombrit toute la page, et clignoterait pour un chargement de quelques dizaines de
 * millisecondes.
 */
const NavigationProgress = () => {
  const navigation = useNavigation();

  if (navigation.state !== "loading") return null;

  return (
    <LinearProgress
      data-cy="navigationProgress"
      sx={{position: "fixed", top: 0, left: 0, right: 0, zIndex: (theme) => theme.zIndex.appBar + 1}}
    />
  );
};

export default NavigationProgress;
